import { render, staticRenderFns } from "./TraditionalBracesConsentForm.vue?vue&type=template&id=ae5624e4&scoped=true"
import script from "./TraditionalBracesConsentForm.vue?vue&type=script&lang=js"
export * from "./TraditionalBracesConsentForm.vue?vue&type=script&lang=js"
import style0 from "./TraditionalBracesConsentForm.vue?vue&type=style&index=0&id=ae5624e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5624e4",
  null
  
)

export default component.exports